import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { FileText } from 'lucide-react';
import { AdminAuthProvider } from './context/AdminAuthContext';
import AdminProtectedRoute from './components/AdminProtectedRoute';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import AdminCandidatesPage from './pages/AdminCandidatesPage';
import AdminCandidateDetailPage from './pages/AdminCandidateDetailPage';
import AdminPaymentsPage from './pages/AdminPaymentsPage';
import AdminJobsPage from './pages/AdminJobsPage';
import AdminJobDetailPage from './pages/AdminJobDetailPage';
import AdminPlaceholderPage from './pages/AdminPlaceholderPage';
import './admin.css';

const AdminApp = () => {
  useEffect(() => {
    document.title = 'isBulsun Admin';
  }, []);

  return (
    <AdminAuthProvider>
      <Router>
        <div className="admin-root">
          <Routes>
            <Route path="/" element={<AdminLoginPage />} />
            <Route
              path="/panel"
              element={
                <AdminProtectedRoute>
                  <AdminDashboardPage />
                </AdminProtectedRoute>
              }
            />
            <Route
              path="/panel/adaylar"
              element={
                <AdminProtectedRoute>
                  <AdminCandidatesPage />
                </AdminProtectedRoute>
              }
            />
            <Route
              path="/panel/adaylar/:id"
              element={
                <AdminProtectedRoute>
                  <AdminCandidateDetailPage />
                </AdminProtectedRoute>
              }
            />
            <Route
              path="/panel/ilanlar"
              element={
                <AdminProtectedRoute>
                  <AdminJobsPage />
                </AdminProtectedRoute>
              }
            />
            <Route
              path="/panel/ilanlar/:slug"
              element={
                <AdminProtectedRoute>
                  <AdminJobDetailPage />
                </AdminProtectedRoute>
              }
            />
            <Route
              path="/panel/basvurular"
              element={
                <AdminProtectedRoute>
                  <AdminPlaceholderPage
                    title="Başvurular"
                    icon={FileText}
                    description="Adayların ilanlara yaptığı başvurular ve durumları burada listelenecek."
                  />
                </AdminProtectedRoute>
              }
            />
            <Route
              path="/panel/abonelikler"
              element={
                <AdminProtectedRoute>
                  <AdminPaymentsPage />
                </AdminProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </AdminAuthProvider>
  );
};

export default AdminApp;
